import React, { FC, useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'
import { Helmet } from 'react-helmet'
import { LangValue } from '../../../../states/types/common'

import { URL } from '../../../constants/url'
import { setUrlId, setPath } from '../../../../utils/url'
import { useTranslation } from 'react-i18next'
import { cloneDeep, filter, sortBy } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Tips from '../../../components/common/Tips'
import { compile } from '../../../../utils/search'

interface CustomTeam {
  [key: number]: string
}

interface MemberList {
  id: number
  active: boolean
  name: string
  team: string | null
  place: string | null
  contract: string | null
  profile_image: string | null
}

const Index: FC = () => {
  const { t } = useTranslation()
  const { language } = useParams<{ language: LangValue }>()
  const history = useHistory()

  const {
    risk,
  } = useSelector((state: RootState) => (state))

  const [memberList, setMemberList] = useState<MemberList[]>()
  const [memberListInit, setMemberListInit] = useState<MemberList[]>()
  const [searchWord, setSearchWord] = useState<string>("")

  const [isDisplayInactive, setIsDisplayInactive] = useState<boolean>(false)

  const search = (words: string) => {
    setSearchWord(words)
    if (!words) {
      setMemberList(cloneDeep(memberListInit))
      return
    }
    const word = words.split(/\s+/)
    const list = filter(memberListInit, (member) => {
      if (member === null) return false
      return (compile(word).test(member.name + member.contract + member.place + member.team))
    }) as MemberList[]
    setMemberList(sortBy(list, 'id'))
  }

  const reset = () => {
    setSearchWord("")
    setMemberList(cloneDeep(memberListInit))
  }

  useEffect(() => {
    if (!risk.riskMembers?.members) return
    let buildMemberList = sortBy(risk.riskMembers?.members.map((member) => ({
      ...member,
      team: member.teams.join(','),
    })), 'id')
    if (!isDisplayInactive) {
      buildMemberList = buildMemberList.filter((v) => v.active)
    }
    setMemberListInit(buildMemberList)
    setMemberList(buildMemberList)
    setSearchWord("")
  }, [risk, isDisplayInactive])

  const handleListClick = (memberId: number) => history.push(setPath(setUrlId(URL.RISK_MEMBER_DETAIL.path, 'id', memberId), language))

  return (
    <section className="risk_page">
      <Helmet>
        <title>Qasee - リスクアセスメント - メンバー一覧</title>
      </Helmet>
      <section className="breadcrumb">
        リスクアセスメント
        &nbsp;&gt;&nbsp;
        メンバー一覧
        &nbsp;
      </section>
      <section className="page_header">
        <h1 className="question">
          メンバー一覧
        </h1>
        <div className="tools">
          <div className="search_box">
            <input
              type="text"
              placeholder={t('member.list.search.placeholder')}
              onChange={(event) => search(event.target.value)}
              value={searchWord}
            />
            {
              searchWord && (
                <button type="button" className="reset" onClick={reset}>
                  <FontAwesomeIcon icon={['far', 'times-circle']} />
                </button>
              )
            }
          </div>
        </div>
      </section>
      <section className="page_contents content-area">
        <section className="content content-area">
          <div className="content-block">
            <div className="block-header">
              <div className="title">
                {t('member.list.table_title')}
              </div>
              <button
                type="button"
                className={`display_switch ${isDisplayInactive ? "check" : ""}`}
                onClick={() => setIsDisplayInactive(!isDisplayInactive)}
              >
                <div>
                  <FontAwesomeIcon icon={['fas', 'users']} />
                  <span>
                    全メンバーを表示
                  </span>
                </div>
                <div>
                  <FontAwesomeIcon icon={['fas', 'user-minus']} />
                  <span>
                    休眠メンバーを非表示
                  </span>
                </div>
              </button>
            </div>
            <div className="block-detail">
              <table className="flex-table member_table">
                <thead>
                  <tr>
                    <th>{t('model.member.name')}</th>
                    <th>{t('model.team.caption')}</th>
                    <th>{t('model.member_detail.contract')}</th>
                    <th>{t('model.member_detail.place')}</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    memberList && memberList.map((member: MemberList) => (
                      <tr key={member.id}>
                        <td>
                          {
                            member.profile_image ? (
                              <img alt="profile" src={member.profile_image} className="profile_icon" />
                            ) : (
                              <img
                                alt=""
                                src={`/static/images/profile/${(member.id || 0) % 12}.jpeg`}
                                className="profile_icon"
                              />
                            )
                          }
                          <span className="link" onClick={() => handleListClick(member.id)} role="none">
                            {member.name}
                          </span>
                          {
                            member.active || (
                              <Tips
                                description="休眠中💤"
                                className=""
                                icon={false}
                                style={{
                                  position: "relative",
                                }}
                              >
                                <>
                                  💤
                                </>
                              </Tips>
                            )
                          }
                        </td>
                        <td>{member.team}</td>
                        <td>{member.contract}</td>
                        <td>{member.place}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </section>
    </section>
  )
}

export default Index
